import DefaultDialogParser from "../../../../lib/html5-software-library/src/ranj/eng/dialog/framework/serialization/DefaultDialogParser";
import { isString } from "../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import LanguagePackLoadedEvent from "../../core/language/controller/LanguagePackLoadedEvent";

/**
* DialogFactory.js
* 
* Created on 3-okt-2013, 15:27:50
*
* @author Ivo Swartjes for Ranj
**/
export default class NGTDialogFactory {
    
    /**
     * 
     * @param {AssetLibrary} assetLibrary 
     * @param {LanguagePack} languagePack 
     * @param {soma.EventDispatcher} dispatcher
     */
    constructor(assetLibrary, languagePack, dispatcher) {
        this.assetLibrary = assetLibrary;
        this.languagePack = languagePack;
        this.dispatcher = dispatcher;
        
        this.dialogCache = {};
        this.dialogParser = new DefaultDialogParser(this.languagePack);
    }

    getDialog(dialogId) {
        // first check if dialog is cached
        let dialog = this.dialogCache[dialogId];
        if (dialog) {
            return dialog;
        }
        // get dialog asset from asset library
        const dialogAsset = this.assetLibrary.getAsset(dialogId);
        if (!dialogAsset) {
            return null;
        }
        // check if dialog asset is a raw string or JSON object
        const jsonObj = isString(dialogAsset) ? JSON.parse(dialogAsset) : dialogAsset;
        // check if JSON is the source dialog (.dlg) or the export dialog JSON
        const dialogJson = this._isSourceDialog(jsonObj) ? this._processSourceDialog(dialogId, jsonObj) : jsonObj;
        // parse Dialog from JSON
        dialog = this.dialogParser.parseFromObject(dialogJson);
        if (!dialog) {
            return null;
        }
        // cache it
        this.dialogCache[dialogId] = dialog;
        
        return dialog;
    }

    _isSourceDialog(jsonObj){
        return jsonObj && jsonObj.hasOwnProperty('dialog');
    }

    /**
     * 
     * @param {{dialog: Object, languagePack: Object}} dialogSourceJson 
     * @returns {Object} dialog JSON
     */
    _processSourceDialog(dialogId, dialogSourceJson) {
        const dialogJson = dialogSourceJson.dialog;
        const lpId = `${dialogId}.lp`;
        // if no LP is present for this dialog id, add the LP from the source dialog
        if(!this.assetLibrary.hasAsset(lpId)) {
            const lp = dialogSourceJson.languagePack;
            this.assetLibrary.addAsset(lpId, lp);
            
            const evt = new LanguagePackLoadedEvent(dialogId, null, lp);
            this.dispatcher.dispatch(LanguagePackLoadedEvent.LOADED, { data: evt });
        }

        return dialogJson;
    }
}

